// api/pendingTasks.ts
// 未処理タスク API クライアント + 型定義
import api from './axios';

export interface TaskItem {
  id: number;
  date: string;
  time: string;
  service: string;
  visit_type: string;
  user_name: string | null;
  doctor_name: string | null;
  is_refill?: boolean;
}

export interface TaskCategory {
  count: number;
  items: TaskItem[];
}

export interface PendingTasksData {
  unassigned_pool:       TaskCategory;
  today_consultations:   TaskCategory;
  questionnaire_pending: TaskCategory;
  record_pending:        TaskCategory;
  shipping_pending:      TaskCategory;
  payment_pending:       TaskCategory;
}

export async function fetchPendingTasks(): Promise<PendingTasksData> {
  const res = await api.get<PendingTasksData>('/pending-tasks');
  return res.data;
}
